import PropTypes from 'prop-types'

export default function IconButton({
  onClick,
  icon,
  disabled,
  className,
  ...props
}) {
  return (
    <button
      className={`tw-custom-button-reset tw-p-2   ${
        disabled
          ? 'tw-cursor-not-allowed tw-text-system-grey-200'
          : 'tw-text-system-grey-300 hover:tw-text-system-grey-400'
      } ${className}`}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      {...props}>
      <i className={`fas fa-${icon}`} />
    </button>
  )
}

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
}
